/**
 * 实体表接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EntityManagementService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 实体表接口
  /**
   * 查询实体表所有信息
   * @param param
   * @returns {Observable<any>}
   */
  queryTableEntityPageList(param) {
    const url = this.prefix + 'tableEntity/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 查看实体表信息
   * @param param
   * @returns {Observable<any>}
   */
  getEntity(param) {
    const url = this.prefix + 'tableEntity/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 更新实体表信息
   * @param param
   * @returns {Observable<any>}
   */
  updateEntity(param) {
    const url = this.prefix + 'tableEntity/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除实体表单个信息
   * @param param
   * @returns {Observable<any>}
   */
  deleteEntity(param) {
    const url = this.prefix + 'tableEntity/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 增加实体表单个信息
   * @param param
   * @returns {Observable<any>}
   */
  saveEntity(param) {
    const url = this.prefix + 'tableEntity/save';
    return this.http.Post(url, param);
  }

  //#endregion


}
